export default __webpack_public_path__ + "static/media/global_bg.c86815c3.png";